// import { useContext, useEffect, useRef } from "react";
// import notificationSound from "../Sound/order_Update_notification.mp3";
// import paymentSound from "../Sound/payment_received.mp3";
// import { GlobalContext } from "../Context/GlobalContext";

// const OrderUpdateWebSocket = ({ onOrderUpdate }) => {
//   const { userID } = useContext(GlobalContext);

//   const audioRef = useRef(null);
//   // Initialize audio once
//   useEffect(() => {
//     const audio = new Audio(notificationSound);
//     audio.preload = "auto";
//     audio.loop = true;
//     audio.volume = 1.0;
//     audioRef.current = audio;

//     // Unlock audio on first user interaction
//     const unlockAudio = () => {
//       audio.muted = true;
//       audio
//         .play()
//         .then(() => {
//           audio.pause();
//           audio.muted = false;
//           localStorage.setItem("soundUnlocked", "true");
//           console.log("🔓 Audio unlocked");
//         })
//         .catch((err) => {
//           console.warn("Unlock failed:", err);
//         });

//       document.removeEventListener("click", unlockAudio);
//       document.removeEventListener("mousemove", unlockAudio);
//     };

//     if (localStorage.getItem("soundUnlocked") !== "true") {
//       document.addEventListener("click", unlockAudio, { once: true });
//       document.addEventListener("mousemove", unlockAudio, { once: true });
//     }

//     return () => {
//       document.removeEventListener("click", unlockAudio);
//       document.removeEventListener("mousemove", unlockAudio);
//     };
//   }, []);

//   useEffect(() => {
//     if (!userID) {
//       console.error("userID is missing. Order update WebSocket not started.");
//       return;
//     }

//     let uniqueId = sessionStorage.getItem("uniqueId");
//     if (!uniqueId) {
//       uniqueId = crypto.randomUUID();
//       sessionStorage.setItem("uniqueId", uniqueId);
//     }

//     let socket;

//     const connectWebSocket = () => {
//       console.log(" Connecting to Order Update WebSocket with userID:", userID);

//       socket = new WebSocket(
//         `wss://api.anlook.com/ws?userId=${uniqueId}&roomId=${userID}_order_update_master_v1`,
//       );

//       socket.onopen = () => {
//         console.log(" Order Update WebSocket Connected");
//       };

//       socket.onmessage = (event) => {
//         try {
//           const data = JSON.parse(event.data);

//           console.log(" Parsed Order Update:", data);

//           //  Smart update handling
//           if (data.Message?.includes("Payment Received For Order")) {
//             setTimeout(() => {
//               onOrderUpdate();

//               window.dispatchEvent(new Event("orderUpdated"));
//             }, 1500);
//           } else {
//             onOrderUpdate();

//             window.dispatchEvent(new Event("orderUpdated"));
//           }

//           // toast.info(data.Message, {
//           //   position: "top-right",
//           //   autoClose: 4000,
//           // });

//           // 🔊 Sound logic
//           let soundToPlay = null;

//           if (data.Message?.includes("Payment Received For Order")) {
//             soundToPlay = new Audio(paymentSound);
//           } else if (data.Message?.includes("Has been acknowledged")) {
//             soundToPlay = new Audio(notificationSound);
//           }

//           if (soundToPlay) {
//             soundToPlay.play().catch(() => {});
//           }
//         } catch (error) {
//           console.error(" Error parsing:", error);
//         }
//       };

//       socket.onerror = (error) => {
//         console.error(" Order Update WebSocket Error:", error);
//       };
//       socket.onclose = (event) => {
//         console.warn(
//           " Order Update WebSocket Closed:",
//           event.reason,
//           "Code:",
//           event.code,
//         );
//         // Reconnect when WebSocket gets closed
//         console.log("♻️ Reconnecting Order Update WebSocket...");
//         connectWebSocket(); // Reconnect on closure
//       };
//     };

//     connectWebSocket(); // Initial connection

//     // Cleanup function when the component unmounts
//     return () => {
//       if (socket) socket.close();
//     };
//   }, [userID]);

//   return null;
// };

// export default OrderUpdateWebSocket;

import { useContext, useEffect, useRef } from "react";
import notificationSound from "../Sound/order_Update_notification.mp3";
import paymentSound from "../Sound/payment_received.mp3";
import { GlobalContext } from "../Context/GlobalContext";

const OrderUpdateWebSocket = ({ onOrderUpdate }) => {
  const { userID } = useContext(GlobalContext);

  const notificationAudioRef = useRef(null);
  const paymentAudioRef = useRef(null);
  const socketRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const isUnmountedRef = useRef(false);

  // Initialize both sounds once
  useEffect(() => {
    const notificationAudio = new Audio(notificationSound);
    notificationAudio.preload = "auto";
    notificationAudio.loop = false;
    notificationAudio.volume = 1;

    const paymentAudio = new Audio(paymentSound);
    paymentAudio.preload = "auto";
    paymentAudio.loop = false;
    paymentAudio.volume = 1;

    notificationAudioRef.current = notificationAudio;
    paymentAudioRef.current = paymentAudio;

    // Browser audio unlock
    const unlockAudio = async () => {
      const audios = [notificationAudio, paymentAudio];

      try {
        for (const audio of audios) {
          audio.muted = true;

          await audio.play();

          audio.pause();
          audio.currentTime = 0;
          audio.muted = false;
        }

        localStorage.setItem("soundUnlocked", "true");
        console.log("Audio unlocked");
      } catch (error) {
        console.warn("Audio unlock failed:", error);
      }

      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
      document.removeEventListener("touchstart", unlockAudio);
    };

    if (localStorage.getItem("soundUnlocked") !== "true") {
      document.addEventListener("click", unlockAudio, { once: true });
      document.addEventListener("keydown", unlockAudio, { once: true });
      document.addEventListener("touchstart", unlockAudio, {
        once: true,
      });
    }

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
      document.removeEventListener("touchstart", unlockAudio);

      notificationAudio.pause();
      notificationAudio.currentTime = 0;

      paymentAudio.pause();
      paymentAudio.currentTime = 0;

      notificationAudioRef.current = null;
      paymentAudioRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!userID) {
      console.error("userID is missing. Order update WebSocket not started.");
      return;
    }

    isUnmountedRef.current = false;

    let uniqueId = sessionStorage.getItem("uniqueId");

    if (!uniqueId) {
      uniqueId = crypto.randomUUID();
      sessionStorage.setItem("uniqueId", uniqueId);
    }

    const playSound = async (audio) => {
      if (!audio) return;

      try {
        audio.pause();
        audio.currentTime = 0;

        await audio.play();
      } catch (error) {
        console.warn("Sound play failed:", error);
      }
    };

    const connectWebSocket = () => {
      if (isUnmountedRef.current) return;

      if (
        socketRef.current &&
        (socketRef.current.readyState === WebSocket.OPEN ||
          socketRef.current.readyState === WebSocket.CONNECTING)
      ) {
        return;
      }

      console.log("Connecting to Order Update WebSocket with userID:", userID);

      const socket = new WebSocket(
        `wss://api.anlook.com/ws?userId=${uniqueId}&roomId=${userID}_order_update_master_v1`,
      );

      socketRef.current = socket;

      socket.onopen = () => {
        console.log("Order Update WebSocket Connected");
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          console.log("Parsed Order Update:", data);

          const message = String(data?.Message || "")
            .trim()
            .toLowerCase();

          const isPaymentMessage =
            message.includes("payment received for order") ||
            message.includes("payment received");

          if (isPaymentMessage) {
            playSound(paymentAudioRef.current);
          } else {
            playSound(notificationAudioRef.current);
          }

          // Refresh order data
          if (isPaymentMessage) {
            setTimeout(() => {
              if (isUnmountedRef.current) return;

              onOrderUpdate?.();
              window.dispatchEvent(new Event("orderUpdated"));
            }, 1500);
          } else {
            onOrderUpdate?.();
            window.dispatchEvent(new Event("orderUpdated"));
          }
        } catch (error) {
          console.error("Error parsing Order Update WebSocket message:", error);
        }
      };

      socket.onerror = (error) => {
        console.error("Order Update WebSocket Error:", error);
      };

      socket.onclose = (event) => {
        console.warn(
          "Order Update WebSocket Closed:",
          event.reason,
          "Code:",
          event.code,
        );

        socketRef.current = null;

        if (isUnmountedRef.current) return;

        clearTimeout(reconnectTimeoutRef.current);

        reconnectTimeoutRef.current = setTimeout(() => {
          console.log("Reconnecting Order Update WebSocket...");
          connectWebSocket();
        }, 3000);
      };
    };

    connectWebSocket();

    return () => {
      isUnmountedRef.current = true;

      clearTimeout(reconnectTimeoutRef.current);

      const socket = socketRef.current;

      if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        socket.close();
      }

      socketRef.current = null;
    };
  }, [userID, onOrderUpdate]);

  return null;
};

export default OrderUpdateWebSocket;